import { checkIsFiltered } from '@/lib/utils/algolia'

import GridArchiveItems from '@/components/grid-archive/GridArchiveItems'
import FilterToolbar from '@/components/filters/FilterToolbar'
import FilterModal from '@/components/filters/FilterModal'
import FilterModalFooter from '@/components/filters/FilterModalFooter'
import FilterModalComponents from '@/components/filters/FilterModalComponents'
import FilterRefinementPillboxList from '@/components/filters/FilterRefinementPillboxList'
import FilterStats from '@/components/filters/FilterStats'
import FilterSearchBox from '@/components/filters/FilterSearchBox'
import FilterPagination from '@/components/filters/FilterPagination'
import FilterVirtualRefinementList from '@/components/filters/FilterVirtualRefinementList'
import type { ArchiveAPIResponseType, FilterPropsType } from '@/layouts/types'

export default function GridArchiveInner({
  filters,
  pillFilter,
  sidebarContent,
  pinnedPost,
  gridRef,
}: {
  filters: FilterPropsType
  pillFilter: ArchiveAPIResponseType['archive_prominent_filters']
  sidebarContent: React.ReactNode
  pinnedPost: ArchiveAPIResponseType['archive_pinned_post']
  gridRef: React.RefObject<HTMLDivElement>
}) {
  const isFiltered = checkIsFiltered()
  const hasArchiveFilters = filters?.length > 0

  return (
    <>
      {hasArchiveFilters ? (
        <div className="hidden" aria-hidden="true">
          <FilterModalComponents filters={filters} />
        </div>
      ) : null}

      <div className="container ms:mt-m">
        <FilterVirtualRefinementList attribute={'authors_taxonomy.name'} />

        <FilterToolbar
          leftChildren={
            hasArchiveFilters ? (
              <div className="flex items-center gap-x-s">
                <FilterModal footerComponent={<FilterModalFooter />}>
                  <FilterModalComponents filters={filters} />
                </FilterModal>

                {pillFilter ? (
                  <FilterRefinementPillboxList filters={pillFilter} className="m:hidden" />
                ) : null}
              </div>
            ) : null
          }
          rightChildren={
            <div className={`flex w-full justify-end gap-x-l`}>
              <FilterSearchBox />
            </div>
          }
        />
      </div>

      {!isFiltered && pinnedPost ? <div className="container mb-l">{pinnedPost}</div> : null}

      <div
        className="container grid grid-cols-1 gap-y-xl"
        ref={gridRef}
        style={{ scrollMarginTop: '80px' }}>
        <GridArchiveItems isFiltered={isFiltered} sidebarContent={sidebarContent} />
      </div>

      <div className="my-m border-t pt-m text-center">
        <div className="container flex items-center justify-between ms:flex-col ms:gap-y-s">
          <FilterStats />
          <FilterPagination gridRef={gridRef} />
        </div>
      </div>
    </>
  )
}
